import React, { useState } from "react";
import { Link } from "react-router-dom";

import Box from "@mui/material/Box";
import { ReactComponent as ReturnLeft } from "../assets/svg/return-left.svg";
import ActionButton from "./ActionButton";

const ReturnToHomeButton = () => {
  const [svgClassName, setSvgClassName] = useState("");

  return (
    <Box
      sx={{ width: "65px" }}
      onMouseEnter={() => setSvgClassName("primary-color")}
      onMouseLeave={() => setSvgClassName("")}
    >
      <Link to="/">
        <ActionButton>
          <ReturnLeft className={svgClassName} />
        </ActionButton>
      </Link>
    </Box>
  );
};

export default ReturnToHomeButton;
